import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  serie: Yup.string()
    .length(4)
    .required(),
  tipoSerie: Yup.string()
    .max(50)
    .required()
})
